module.exports = __webpack_public_path__ + "static/vid-preview-ae88e561707cf6fa2fdb26f3b0c90800.mp4";